import { ReactNode } from 'react'
import { SvgMapNeedle } from '@/icons/svg-map-needle'

interface IRestaurantsPageHeadingProps {
    title: string
    /** One or more lines of supporting copy under the title. */
    children?: ReactNode
}

/**
 * Shared by the city page, the brands hub and the brand pages.
 *
 * The needle renders inside the `h1` rather than beside it: as a flex sibling it centred
 * against the whole block, so once a longer title wrapped to two lines on mobile the pin
 * floated alongside the first line, detached from the text.
 */
export const RestaurantsPageHeading = ({ title, children }: IRestaurantsPageHeadingProps) => {
    return (
        <div className="w-full flex items-center justify-center px-4 md:px-0 mb-8 md:mb-10">
            <div className="flex flex-col items-center" style={{ maxWidth: 'min(1183px, 80vw)' }}>
                <h1 className="text-[32px] md:text-[48px] font-bold text-center text-balance mb-1">
                    {title}

                    <span className="inline-flex align-middle ml-3">
                        <SvgMapNeedle color="none" size={33} />
                    </span>
                </h1>

                {children}
            </div>
        </div>
    )
}
